<template>
<div class="heading" v-if="loaded && codiceTipo">
  <span>Codice articolo</span>
<etichetta v-if="newLabels.includes(data.id_ref_etichetta)" v-for="(data, i) in datasheet" :etichetta="data.id_ref_etichetta" :key="i"/>
</div>
</template>

<script>
import etichetta from "./etichetta";
export default {
  name: "datasheet-heading",
  components: {
    etichetta
  },
  props: ['datasheet'],
  data() {
    return {
      labelsToShow: [1,2,3,4,5,6,7],
      codiceTipo: (this.datasheet.length > 0) ? this.datasheet[0].cod_tipo : false,
      newLabels: null,
      loaded: false,
    }
  },
  mounted() {
    this.parseLabels()
  },
  methods: {
    parseLabels(){
      let newLabels = []
      this.labelsToShow.forEach((el)=>{
        let temp = this.codiceTipo + '-' + el
        newLabels.push(temp)
      })
      this.newLabels = newLabels
      this.$emit('labels', newLabels)
      this.loaded = true
    },

  },
}
</script>

<style lang="scss" scoped>
.heading {
  display: none;
  font-size: 14px;
  margin-top: 50px;
  margin-bottom: 40px;
  //padding-left: 50px;
  flex-direction: column;

  span {
    display: inline-block;
    width: calc(100% / 7);
    text-align: center;
    text-transform: capitalize;

    &.diametro,
    &.peso {
      width: calc(100% / 12);
    }
  }
}
</style>
